import * as angular from 'angular';
import { ReportViewerFacade } from '@mode/report-viewer/domain';

class ReportPresentationController {
  static $inject = ['ReportViewerFacade'];

  constructor(private reportViewerFacade: ReportViewerFacade) {}
}

export const ID = 'reportPresentation';

export const reportPresentation: angular.IComponentOptions = {
  template: `
    <div class="report-details">
      <div class="code-container">
        <div
          mode-code
          lang="markup"
          line-numbers="true"
          ng-if="ctrl.reportViewerFacade.hasRun$ | async:this"
        >{{ctrl.reportViewerFacade.reportLayoutNoEmpty$ | async:this}}
        </div>
      </div>
    </div>
  `,
  controller: ReportPresentationController,
  controllerAs: 'ctrl',
};
